import { getHours, getMinutes, setHours, setMinutes } from 'date-fns';

export const setTime = (date: Date, time: Date): Date => setHours(setMinutes(date, getMinutes(time)), getHours(time));
